import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/document-redactor")({
  staticData: {
    title: "Document Redactor",
  },
  component: () => <Outlet />,
});
